@let StatusCodesValues = StatusCodes();

<mat-card
  *transloco="let t; prefix: i18nPrefix()"
  class="overflow-hidden relative h-full"
  [formGroup]="parentForm()"
>
  <mat-card-content>
    <div class="flex w-full flex-col sm:flex-row gap-8">
      <pct-form-string-slide-toggle
        formControlName="status"
        nameAttribute="status"
        [defaultValue]="StatusCodesValues[0]"
        [falseValue]="StatusCodesValues[1]"
        [label]="{ text: t('STATUS'), translate: false }"
        [trueValue]="StatusCodesValues[0]"
      />
      <mat-slide-toggle formControlName="isHighlighted" name="is-highlighted">{{
        t('HIGHLIGHTED')
      }}</mat-slide-toggle>
      @if (showIsUniversity()) {
        <mat-slide-toggle name="isUniversity" [formControlName]="isUniversityControlName()">
          {{ t('IS_UNIVERSITY') }}
        </mat-slide-toggle>
      }
      @if (showIsPublishNotificationEnabled()) {
        <mat-slide-toggle
          formControlName="isPublishNotificationEnabled"
          name="isPublishNotificationEnabled"
        >
          {{ t('IS_PUBLISH_NOTIFICATION_ENABLED') }}
        </mat-slide-toggle>
      }
    </div>
    <mat-divider class="!my-4" style="margin-left: -1rem; margin-right: -1rem" />
    <div class="flex flex-col w-full gap-3">
      <pct-form-autocomplete
        formControlName="categoryIds"
        fullWidth="true"
        multiple="true"
        nameAttribute="category-ids"
        [inputService]="categoryDtoService()"
        [label]="{ text: t('CATEGORY'), translate: false }"
      />
      @if (showLocation()) {
        <pct-form-autocomplete
          fullWidth="true"
          nameAttribute="location-id"
          [formControlName]="locationIdControlName()"
          [inputService]="locationDtoService()"
          [label]="{ text: t('LOCATION'), translate: false }"
        />
      }
    </div>
  </mat-card-content>
  @if (loading()) {
    <pct-common-progress-bar />
  }
</mat-card>
